import styles from "./PrintButton.module.css";

import handlePrintLabel from "../../utils/printLabel";


function PrintButton({ data }) {
  return (
    <button
        onClick={() => handlePrintLabel(data)}
      className={styles.printButton}
      title="Print Label"
      //   disabled={!!editingOrder}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
        />
      </svg>
    </button>
  );
}
export default PrintButton;
